import React, { useState, useEffect, useMemo } from 'react';
import axios from 'axios';
import { APP_API_URL } from '../../utils';
import { useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import DuoModal from '../../components/ui/duo-modal';

export default function Update({ open, onClose, categories, category, refreshData }) {
  const user = useSelector((state) => state.auth.user);
  const [formData, setFormData] = useState({
    nom: '',
    type_categorie: '',
    private: true,
    user_id: user?.id,
  });
  const [errors, setErrors] = useState({});
  const [isLoading, setLoading] = useState(false);

  const mainCategories = useMemo(
    () => (categories || []).filter((c) => c.type_categorie === null),
    [categories]
  );

  useEffect(() => {
    if (!category) return;
    setFormData({
      nom: category.nom,
      type_categorie: category.type_categorie?.id ?? '',
      private: Number(category.private) === 0,
      user_id: user?.id,
    });
    setErrors({});
  }, [category, user?.id]);

  if (!open || !category) return null;

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : name === 'type_categorie' ? Number(value) || '' : value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      await axios.put(
        `${APP_API_URL}/categories/${category.id}`,
        {
          ...formData,
          type_categorie: formData.type_categorie || null,
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      await Swal.fire({
        icon: 'success',
        title: 'Succès',
        text: 'La sous-catégorie a été mise à jour avec succès.',
        timer: 2000,
        showConfirmButton: false,
      });

      onClose();
      refreshData();
    } catch (error) {
      if (error.response?.status === 422) {
        setErrors(error.response.data.errors);
        Swal.fire({
          icon: 'error',
          title: 'Erreur de validation',
          text: 'Veuillez vérifier les champs du formulaire.',
        });
      } else {
        console.error("Erreur lors de l'envoi du formulaire", error);
        Swal.fire({
          icon: 'error',
          title: 'Erreur',
          text: 'Une erreur est survenue. Veuillez réessayer.',
        });
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <DuoModal
      title={`Modifier sous-catégorie — ${category.nom}`}
      onClose={onClose}
      footer={
        <>
          <button type="button" className="duo-btn duo-btn--ghost" onClick={onClose} disabled={isLoading}>
            Annuler
          </button>
          <button
            type="submit"
            form={`update-subcategory-form-${category.id}`}
            className="duo-btn duo-btn--primary"
            disabled={isLoading}
          >
            {isLoading ? 'Enregistrement...' : 'Enregistrer'}
          </button>
        </>
      }
    >
      <form id={`update-subcategory-form-${category.id}`} onSubmit={handleSubmit}>
        <div className="duo-form-group">
          <label htmlFor={`sub-nom-${category.id}`} className="duo-form-label">
            Nom de la sous-catégorie *
          </label>
          <input
            type="text"
            className="duo-input"
            id={`sub-nom-${category.id}`}
            name="nom"
            value={formData.nom}
            onChange={handleChange}
          />
          {errors.nom && <p className="text-danger small mt-1 mb-0">{errors.nom[0]}</p>}
        </div>
        <div className="duo-form-group">
          <label htmlFor={`sub-parent-${category.id}`} className="duo-form-label">
            Catégorie parente *
          </label>
          <select
            id={`sub-parent-${category.id}`}
            name="type_categorie"
            className="duo-select"
            value={formData.type_categorie}
            onChange={handleChange}
          >
            <option value="">Sélectionner une catégorie</option>
            {mainCategories.map((cat) => (
              <option key={cat.id} value={cat.id}>
                {cat.nom}
              </option>
            ))}
          </select>
          {errors.type_categorie && (
            <p className="text-danger small mt-1 mb-0">{errors.type_categorie[0]}</p>
          )}
        </div>
        <div className="duo-form-group mb-0">
          <label className="duo-form-label d-flex align-items-start gap-2">
            <input
              type="checkbox"
              className="form-check-input mt-1"
              name="private"
              checked={formData.private}
              onChange={handleChange}
            />
            <span>
              Sous-catégorie active
              <span className="d-block fw-normal" style={{ fontSize: '0.78rem', color: '#777' }}>
                Décochez pour la rendre inactive.
              </span>
            </span>
          </label>
          {errors.private && <p className="text-danger small mt-1 mb-0">{errors.private[0]}</p>}
        </div>
      </form>
    </DuoModal>
  );
}
